<template>
  <cs-dialog v-model="show">
    <div id="capustaInfo" class="capusta_info">
      <button class="capusta_info-close" @click="closeInfo" />

      <component :is="component" v-if="component">
        <button class="capusta_info-done" @click="closeInfo">
          {{ $t('common.ok') }}
        </button>
      </component>
    </div>
  </cs-dialog>

  <!-- <div v-if="show" id="overlay" ref="overlay" class="capusta_info-overlay" @click.self="closeInfo">

  </div> -->
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { events } from './events';

const DEFAULT_TEMPLATE = 'defaultInfo';

import DefaultInfo from './templates/defaultInfo';
import BillIframe from './templates/billIframe';
import Registration from './templates/registration';

export default {
  name: 'CapustaInfo',
  components: {
    DefaultInfo,
    BillIframe,
    Registration,
  },
  mounted() {
    events.$on('show', this.showInfo);
  },
  data() {
    return {
      show: false,
      component: null,
    };
  },
  methods: {
    showInfo(templateName) {
      if (!templateName) {
        this.component = DEFAULT_TEMPLATE;
        return;
      }

      disableBodyScroll(this.$refs.overlay);

      this.component = templateName;
      this.show = true;
    },
    closeInfo() {
      this.show = false;
      enableBodyScroll();
    },
  },
};
</script>

<style lang="sass" scoped>
  .capusta_info-overlay
    +full-size(0, fixed)
    +flex-center
    z-index: 10
    width: 100%
    height: 100vh

  .capusta_info
    width: calc(100% - (.64rem * 2))
    max-width: 35.71rem
    max-height: 70vh
    align-self: center
    border-radius: 0.48rem
    background-color: $pure-white
    padding: 2.85rem 0
    box-shadow: 0 0 2.84rem rgba(248, 248, 248, 0.6)
    position: relative
    overflow: hidden
    display: flex

    @media (max-width: 480px)
      padding: 2rem 0

    @media (max-width: 360px)
      padding: 1.6rem 0

  .capusta_info-content
    overflow: auto
    -webkit-overflow-scrolling: touch
    padding: 0 2.85rem

    @media (max-width: 480px)
      padding: 0 2rem

    @media (max-width: 360px)
      padding: 0 1.6rem

  .capusta_info-close
    width: 17px
    height: 17px
    padding: 0
    position: absolute
    right: 1rem
    top: 1rem
    z-index: 2
    background-color: transparent
    +flex-center()
    cursor: pointer
    transition: .2s ease

    // @media (max-width: 480px)
    //   top: 0
    //   right: 0

    // @media (max-width: 360px)
    //   padding: 1.4rem

    &::before,
    &::after
      content: ''
      position: absolute
      width: 17px
      height: 2px
      background-color: #000

    &::before
      transform: rotate(45deg)
    &::after
      transform: rotate(-45deg)
    &:hover
      transform: scale(1.1)

  .capusta_info-done
    font-size: 1.12rem
    font-weight: 600
    width: 100%
    margin: 0 auto
    display: block
    padding: 0.8rem
    color: $soft-white
    border-radius: 2.48rem
    background-color: #7CB342

    @media (min-width: 767px)
      max-width: 12.85rem

    &:hover
      color: $pure-white

    &:disabled,
    &.disabled
      cursor: not-allowed
      background-color: #4e5a5f

    &.loading
      font-size: 0
      cursor: progress

      &::after
        content: '. . .'
        font-size: 1.12rem
</style>
